import React, { useMemo, useState } from 'react';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { App, Button, notification, Space, Table, Input, Dropdown } from 'antd';
import { _T } from "../../../../../base-react/src/Localization";
import { DeleteOutlined } from "@ant-design/icons";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var JudgeSource = models.judges.JudgeSource;
var JudgeItem = models.judges.JudgeItem;
import { SearchCompetitionUser } from '../../../../components/SearchCompetitionUser';
import { useCompetition } from '../../../../../base-react/hooks/Competition';
import { ExternalAPI } from '../../../../components/ExternalAPI';
import { ApplicationStatusDot, getActiveApplicationUserIds } from '../../../../components/ApplicationStatusDot';
export const JudgeCompetitionList = (props) => {
    let { event_id, competition_id, disabled } = props;
    const [inputCompetition, event, competitions, loadingCompetitions] = useCompetition(competition_id);
    const [judges, loadingJudges, errorJudges] = Stream(JudgeSource(competition_id));
    const [applications] = Stream(models.applications.CompetitionApplicationsSource(event_id));
    const [isLoading, setIsLoading] = useState();
    const [draftLetters, setDraftLetters] = useState({});
    const { modal } = App.useApp();
    const activeJudgeUserIds = useMemo(() => getActiveApplicationUserIds(applications, 'judging'), [applications]);
    const onAddItem = async (item) => {
        await Api.create(JudgeSource(competition_id).url, item)
            .catch((err) => {
            notification.error({
                message: err.message
            });
        });
    };
    const onChangeLetter = async (text, item) => {
        setIsLoading(item.judge_id);
        await Api.update(`${JudgeSource(competition_id).url}/${item.judge_id}`, {
            ...item,
            judge_letter: text
        })
            .catch((err) => {
            setIsLoading(undefined);
            notification.error({
                message: err.message
            });
        });
        setIsLoading(undefined);
    };
    const handleLetterChange = (value, item) => {
        if (item.judge_id === undefined || item.judge_id === null) {
            return;
        }
        const judgeKey = String(item.judge_id);
        setDraftLetters(prev => ({ ...prev, [judgeKey]: value }));
    };
    const commitLetterChange = (item) => {
        if (item.judge_id === undefined || item.judge_id === null) {
            return;
        }
        const judgeKey = String(item.judge_id);
        const nextValue = draftLetters[judgeKey];
        if (nextValue === undefined || nextValue === item.judge_letter) {
            return;
        }
        void onChangeLetter(nextValue, item);
    };
    const onChangeMIN = async (text, item) => {
        setIsLoading(item.judge_id);
        await Api.call(`${JudgeSource(competition_id).url}/${item.judge_id}`, 'assign-wdsf-min', {
            user_id: item.user_id,
            team_refnr: text
        })
            .catch((err) => {
            notification.error({
                message: err.response && err.response.message ? _T(err.response.message) : err.message
            });
        });
        setIsLoading(undefined);
    };
    const onResetPin = (item) => {
        modal.confirm({
            title: _T('judges.pin.reset'),
            content: _T('judges.pin.resetConfirm', { name: JudgeItem.getFullName(item) }),
            okButtonProps: { loading: isLoading === item.judge_id, disabled },
            cancelButtonProps: { disabled },
            onOk: async () => {
                setIsLoading(item.judge_id);
                await Api.call(`${JudgeSource(competition_id).url}/${item.judge_id}`, 'pin-reset')
                    .catch((err) => {
                    notification.error({ message: _T(err.response && err.response.message ? err.response.message : err.message) });
                })
                    .finally(() => setIsLoading(undefined));
            }
        });
    };
    const onDeleteItem = (item) => {
        modal.confirm({
            title: _T('common.delete.title', { name: _T('users.title').toLowerCase() }),
            content: _T('common.delete.content', { name: JudgeItem.getFullName(item) }),
            onOk() {
                setIsLoading(item.judge_id);
                Api.destroy(`${JudgeSource(competition_id).url}/${item.judge_id}`)
                    .then(() => {
                    setIsLoading(undefined);
                })
                    .catch((err) => {
                    setIsLoading(undefined);
                    notification.error({
                        message: _T(err.response ? err.response.message : err.name)
                    });
                });
            }
        });
    };
    const columns = [
        {
            width: 24,
            align: 'center',
            render: (item) => (React.createElement(ApplicationStatusDot, { connected: activeJudgeUserIds.has(String(item.user_id)), applicationName: "judging", applicationUserId: item.user_id }))
        },
        {
            title: _T('users.name'),
            dataIndex: 'user_firstname',
            render: (user_firstname, item) => (JudgeItem.getFullName(item))
        },
        {
            title: _T('users.email'),
            dataIndex: 'user_email',
            responsive: ['md'],
        },
        {
            title: _T('judges.letter.title'),
            dataIndex: 'judge_letter',
            render: (text, item) => (React.createElement(Input, { value: item.judge_id !== undefined &&
                    item.judge_id !== null &&
                    draftLetters[String(item.judge_id)] !== undefined
                    ? draftLetters[String(item.judge_id)]
                    : text, disabled: disabled, onChange: e => handleLetterChange(e.target.value, item), onBlur: () => commitLetterChange(item), onPressEnter: () => commitLetterChange(item) }))
        },
        (inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.competition_federation) === 'WDSF' ? {
            title: 'WDSF MIN',
            dataIndex: 'team_refnr',
            render: (text, item) => (React.createElement(Space.Compact, { style: { width: '100%' } },
                React.createElement(Input, { value: text, disabled: disabled, onChange: e => onChangeMIN(e.target.value, item) }),
                React.createElement(ExternalAPI, { competition_id: competition_id, mode: 'judges', nameOrMin: text, onClick: record => onChangeMIN(record.id, item), disabled: disabled })))
        } : {},
        {
            width: 20,
            render: (item) => (React.createElement(Button, { type: "text", icon: React.createElement(DeleteOutlined, null), onClick: () => onDeleteItem(item), loading: isLoading === item.judge_id }))
        },
        {
            width: 110,
            render: (item) => (React.createElement(Button, { type: "link", onClick: () => onResetPin(item), disabled: disabled || !item.judge_pin_created, loading: isLoading === item.judge_id }, _T('judges.pin.reset') || 'Reset PIN'))
        },
    ].flat().filter(column => Object.keys(column).length > 0);
    const items = ['firstname', 'lastname', 'nickname'].map(value => ({
        key: value,
        label: _T('judges.letter.' + value)
    }));
    const handleMenuClick = async (e) => {
        let alphabet = new Array(26).fill(1).map((_, i) => String.fromCharCode(65 + i));
        if (e.key == "nickname") {
            for (let judge of judges) {
                onChangeLetter(judge.user_firstname, judge);
            }
        }
        else {
            const firstAttr = e.key == "firstname" ? "user_firstname" : "user_lastname";
            const secondAttr = e.key == "firstname" ? "user_lastname" : "user_firstname";
            const sortedJudges = judges.sort((a, b) => (a[firstAttr] + a[secondAttr]) < (b[firstAttr] + b[secondAttr]) ? -1 : 1);
            let i = 0;
            let x = 1;
            for (let judge of sortedJudges) {
                onChangeLetter(alphabet[i].repeat(x), judge);
                i++;
                if (i >= alphabet.length) {
                    x++;
                    i = 0;
                }
            }
        }
    };
    const menuProps = {
        items,
        onClick: handleMenuClick,
    };
    const footer = () => (React.createElement(Space, { orientation: 'vertical', style: { width: '100%' } },
        React.createElement(SearchCompetitionUser, { event_id: event_id, callback: onAddItem, disabled: disabled }),
        React.createElement(Dropdown, { menu: menuProps, disabled: disabled },
            React.createElement(Button, null, _T('judges.letter.assign')))));
    return (React.createElement(Table, { size: "small", columns: columns, loading: loadingJudges, rowKey: item => item.judge_id, dataSource: judges, pagination: false, footer: footer }));
};
